"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("permission", {
    url: "/permission",
    template: require("./permission.html"),
    controller: "PermissionController",
    controllerAs: "permissionCtrl",
    authenticate: true,
  });
}



// WEBPACK FOOTER //
// ./client/app/permission/permission.routes.js